<!--Copy right - © 2024 tecera gmbh-->
<script>
    export let id;
    export let label;
    export let toggle = false;
    export let classes = "";
</script>

<div class="input-group {classes}">
    <p class="p-modal">{label}</p>
    <label class="switch ml-4 mt-2">
        <input id={id} type="checkbox" bind:checked={toggle}/>
        <span class="slider round"></span>
    </label>

</div>